import { render, staticRenderFns } from "./TelegramCampaignForContractors.vue?vue&type=template&id=8f7a2676&"
import script from "./TelegramCampaignForContractors.vue?vue&type=script&lang=js&"
export * from "./TelegramCampaignForContractors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports